import React from "react";
import Header from "./ui/header";
import Table from "./ui/table";

export default function GamesSports() {
  return (
    <article className="text-primary">
      <Header />
      <Table />
    </article>
  );
}
